import React, { Component } from 'react'
import axios from 'axios'
import { get } from 'lodash'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import ListData from '../../components/ListData'
import { downloadJson } from '../../utils'
import GabaritoModal from '../../containers/modals/GabaritoModal'
import { API_HOST, getExamsUrl } from '../../consts'
import AgendarAplicacaoModal from './AgendarAplicacaoModal'
import TabelaAplicacoes from './TabelaAplicacoes'
import ExportarAvaliacaoModal from './ExportarAvaliacaoModal'
import ImportarVetoresModal from '../../containers/modals/ImportarVetoresModal'
import EnviarAplicacaoModal from './EnviarAplicacaoModal'
import AddButton from '../../components/buttons/AddButton'
import { ItemStyleButton } from './styles'
import { IconButton, Menu, MenuItem, Button, } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { withTheme } from 'styled-components'
import queryString from 'query-string'
import Tour from 'reactour'
import Steps from "../../contexts/StepReactTour/steps"
import VisibilityIcon from '@material-ui/icons/Visibility';
import PreviewModal from '../../containers/modals/PreviewModal';
import { TrackGoogleAnalyticsEvent } from '../../utils/googleAnalytics';
import { ClickAllTrilhas, ClickAllTrilhasAction } from '../../utils/googleAnalytics/events/TrilhasAdaptativas/EventAllTrilhas';
import ExportErroModalAvaliacao from './ExportErroModalAvaliacao'

class AvaliacaoItem extends Component {
  state = {
    isOpenPreview: false,
    previewContent: null,
    idCollection: null,
    isOpenGabarito: false,
    isOpenAgendar: false,
    isOpenExportar: false,
    aplicacoes: [],
    aplicacaoAtual: null,
    anchorEl: null,
    componente_curricular_label: '-',
    isTourOpen: false,
    openModalError: false,
    messageErro: [],
    // haveApplication: false,
  };

  defaultFetchAplicacoesArgs = {
    loading: true,
    values: {}
  };

  fetchMe(item) {
    const token = localStorage.getItem('token')
    axios
      .get(`${API_HOST}/login/me`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      })
      .then((response) => {
        let groups = response.data.logged_group.map((f) => {
          return f.toUpperCase()
        })
        this.setState({
          isDisabled:
            groups.includes('ADMINISTRADOR') || groups.includes('DRE')
              ? false
              : item && response.data.id == item.criado_por_id
                ? false
                : true,
          me: response.data
        })
      })
      .catch((response) => console.log(response.error))
  }

  analytcsClick = (name, type) => {
    let label = "Click" + ": " + name;
    let category = ClickAllTrilhas + "_" + type;

    TrackGoogleAnalyticsEvent(
      category,
      ClickAllTrilhasAction,
      label,
    );
  };

  fetchAplicacoes = ({ loading, params } = this.defaultFetchAplicacoesArgs) => {

    if (loading) {
      this.setState({ fetchingAplicacoes: true });
    }

    const { avaliacao } = this.props
    const axiosParams = {
      avaliacao: avaliacao.id,
      ...params
    }

    axios
      .get(`${API_HOST}/aplicacoes/aplicacao`, { params: axiosParams })
      .then((response) => {
        const aplicacoes = response.data.results || response.data
        this.setState({ aplicacoes, fetchingAplicacoes: false })


      })
      .catch(() => {
        toast.error('Ocorreu um erro ao carregar as aplicações.')
        this.setState({ fetchingAplicacoes: false })
      })
  };

  openPreviewModal = () => {
    const previewContent = (
      <div>
        <p>Conteúdo de pré-visualização</p>
      </div>
    )

    this.setState({
      isOpenPreview: true,
      previewContent,
    })
  };

  closePreviewModal = () => {
    this.setState({
      isOpenPreview: false,
      previewContent: null,
    })
  };

  openGabaritoModal = () => {
    this.setState({
      isOpenGabarito: !this.state.isOpenGabarito
    })
  };

  openAgendarModal = () => {
    this.setState({
      isOpenAgendar: !this.state.isOpenAgendar
    })
  };

  toggleAplicacoes = () => {
    const { showAplicacoes } = this.state
    this.setState({ showAplicacoes: !showAplicacoes })
  };

  toggleAgendarAplicacaoModal = (aplicacao) => {
    const { avaliacao } = this.props
    const criarNovaAplicacao = aplicacao === null
    let aplicacaoAtual

    if (criarNovaAplicacao) {
      aplicacaoAtual = { avaliacao: avaliacao.id, id: 'new' }
    } else {
      aplicacaoAtual = { ...aplicacao }
    }

    const toggleModal = () => this.toggleModal('agendarAplicacao')
    this.setState({ aplicacaoAtual }, toggleModal)
  };

  toggleExportarAvaliacaoModal = (aplicacao) => {
    const { avaliacao } = this.props
    const criarNovaAplicacao = aplicacao === null
    let aplicacaoAtual

    if (criarNovaAplicacao) {
      aplicacaoAtual = { avaliacao: avaliacao.id, id: 'new' }
    } else {
      aplicacaoAtual = { ...aplicacao }
    }

    const toggleModal = () => this.toggleModal('exportarAvaliacao')
    this.setState({ aplicacaoAtual }, toggleModal)
  };

  toggleEnviarAvaliacaoModal = (idCollection) => {
    const toggleModal = () => this.toggleModal('enviarAplicacao')
    this.setState({ idCollection: idCollection }, toggleModal)
  };

  toggleImportarVetoresModal = () => {
    const toggleModal = () => this.toggleModal('importarVetores')
    this.setState(toggleModal)
  };

  openModalError = () => {
    const { openModalError } = this.state
    this.setState({ openModalError: !openModalError })
  };

  handleExportToExams = () => {
    const { avaliacao } = this.props
    axios
      .get(`${API_HOST}/avaliacoes/avaliacao/${avaliacao.id}/exame`)
      .then((response) => {
        toast.success('Aplicação enviada com sucesso.')
        this.toggleEnviarAvaliacaoModal(response.data.collection.id)
      })
      .catch(({ response }) => {
        if (response && response.status === 400) {
          this.openModalError()
          this.setState({ messageErro: response.data })
        } else if (response && response.status === 500) {
          toast.error('Ocorreu um erro ao gerar o JSON da avaliação.')
        }
      })
  };

  handleCollections = () => {
    const { avaliacao } = this.props
    axios
      .get(`${API_HOST}/avaliacoes/avaliacao/${avaliacao.id}/collection`)
      .then((response) => {

        if (response.data[0] && response.data[0].external_id) {
          this.setState({ haveApplication: true })
          this.setState( { idCollection:   response.data[0].collection.id } )
        }


      })
  };



  handleDownloadJson = () => {
    const { avaliacao } = this.props
    axios
      .get(`${API_HOST}/avaliacoes/avaliacao/${avaliacao.id}/download`)
      .then((response) => {
        downloadJson(response.data, avaliacao.nome)
        toast.success('Download realizado com sucesso.')
      })
      .catch(() => {
        toast.error('Ocorreu um erro ao gerar o JSON da avaliação.')
      })
  };

  toggleModal = (modal) => {
    const { openModal } = this.state
    this.setState({ openModal: openModal === modal ? null : modal })
  };

  handleRemoverAplicacao = (aplicacao) => {
    axios
      .delete(`${API_HOST}/aplicacoes/aplicacao/${aplicacao.id}`)
      .then(() => {
        toast.success('Aplicação removida com sucesso.')

        const { aplicacoes } = this.state
        this.setState({
          aplicacoes: aplicacoes.filter((d) => d.id !== aplicacao.id)
        })
      })
  };

  getComponentCurricular = () => {
    let params;

    if (this.props.avaliacao.componente_curricular !== null) {
      params = {
        id: this.props.avaliacao.componente_curricular
      };

      axios
        .get(`${API_HOST}/core/componente_curricular`, { params })
        .then((response) => {
          this.setState({
            componente_curricular: response.data[0]
          })
        })
    };
  }

  componentDidMount() {
    this.getComponentCurricular()


  }

  renderAplicacoes() {
    const { fetchingAplicacoes, showAplicacoes, aplicacoes } = this.state

    if (!showAplicacoes) {
      return null
    }

    return (
      <React.Fragment>
        <TabelaAplicacoes
          aplicacoes={aplicacoes}
          editar={this.toggleAgendarAplicacaoModal}
          remover={this.handleRemoverAplicacao}
          fetchAplicacoes={this.fetchAplicacoes}
          fetchingAplicacoes={fetchingAplicacoes}
        />
      </React.Fragment>
    )
  }

  render() {
    const { isOpenPreview } = this.state

    const CustumizeButton = withStyles(() => ({
      root: {
        textTransform: 'none',
        fontFamily: 'Quicksand',
        padding: '8px 12px 8px 12px',
        width: 'auto',
        minWidth: '70px',
        height: '35px',
        backgroundColor: `${this.props.theme.primary}`,
        borderRadius: '53px',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        color: '#fff',
        fontWeight: 'bold',
        '&:hover': {
          backgroundColor: `${this.props.theme.buttonHover}`
        }
      }
    }))(Button)

    const { avaliacao, onCopy, onRemove, templates, keyTooltip, me, tipoId, categoria } =
      this.props
    const { aplicacaoAtual, anchorEl, idCollection, componente_curricular, haveApplication } =
      this.state
    const { openModal } = this.state
    const groups =
      me.logged_group &&
      me.logged_group.map((f) => {
        return f.toUpperCase()
      })
    const open = Boolean(anchorEl)

    const handleClick = (event) => {
      this.setState({ anchorEl: event.currentTarget })
      this.handleCollections()

    }

    const handleClose = () => {
      this.setState({ anchorEl: null })
    }

    const isAdmin = groups.includes('ADMINISTRADOR')
    const isOwner = me.id === get(avaliacao, 'criado_por_id') ? true : false
    const isDisabled =
      me && groups
        ? groups.includes('ADMINISTRADOR') || groups.includes('DRE')
          ? false
          : me.id !== get(avaliacao, 'criado_por_id')
            ? true
            : false
        : true
    return (
      <>
        <Tour
          steps={Steps}
          isOpen={this.props.isTourOpen}
          onRequestClose={() => this.setState({ isTourOpen: false })}
        />
        <div className="item" key={avaliacao.id} data-tour="form-informacao3" >
          <div className="container">
            <div
              className="row"
              style={{
                flexWrap: 'nowrap',
              }}
            >
              <div className="col-lg-8 col-md-8 col-sm-10 col-xs-10">
                <ListData
                  atividadeId={get(avaliacao, 'id')}
                  description={[
                    {
                      label: 'Criado por:',
                      value: get(avaliacao, 'criado_por') || '-'
                    },
                    {
                      label: 'N. de objetos de aprendizagem:',
                      value: get(avaliacao, 'itens') || '-'
                    },
                    {
                      label: 'Pontos da Avaliação:',
                      value: get(avaliacao, 'valor') || '-'
                    },
                    {
                      label: 'Agendamentos:',
                      value: get(avaliacao, 'aplicacoes') || '-'
                    }
                  ]}
                  title={get(avaliacao, 'nome', '-')}
                  atualizado_em={get(avaliacao, 'atualizado_em') || '-'}
                  versao={1}
                  componente_curricular={componente_curricular}
                />
                <ItemStyleButton>
                  {/* <AddButton
                    type="button"
                    onClick={this.toggleAplicacoes}
                    title="Agendamentos"
                    icon="eye"
                    classes="mb-3 mr-2 pr-3 button-primary"
                    backgroundType="light"
                  /> */}
                  <AddButton
                    onClick={() => {
                      this.analytcsClick(`Gabarito`, 'Avaliação Card');
                      this.toggleModal('gabarito')
                    }}
                    type="button"
                    icon="clipboard"
                    title="Gabarito"
                    classes="mb-3 mr-2 pr-3  button-terciario"
                    backgroundType="secondary"
                  />
                  <GabaritoModal
                    toggle={() => this.toggleModal('gabarito')}
                    isOpen={openModal === 'gabarito'}
                    avaliacao={avaliacao.id}
                  />

                  <PreviewModal
                    isOpen={isOpenPreview}
                    toggle={this.closePreviewModal}
                    item={avaliacao}
                    isAdmin={isAdmin}
                    onCopy={onCopy}
                    isOwner={isOwner}
                    tipoId={tipoId}
                  />
                  <ExportErroModalAvaliacao
                    open={this.state.openModalError}
                    data={this.state.messageErro}
                    handleClose={this.openModalError}
                  />
                  {/* <AddButton
                    onClick={() => this.toggleAgendarAplicacaoModal(null)}
                    type="button"
                    // className="btn btn-padrao bg-verde mb-3 mr-2 pr-3"
                    icon="plus"
                    title="Agendar Atividade"
                    classes="mb-3 mr-2 pr-3 button-secondary"
                  /> */}
                </ItemStyleButton>
                <AgendarAplicacaoModal
                  isOpen={openModal === 'agendarAplicacao'}
                  toggle={() => this.toggleAgendarAplicacaoModal(null)}
                  aplicacao={aplicacaoAtual}
                  fetchAplicacoes={this.fetchAplicacoes}
                />
              </div>

              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}
              >
                <div
                  style={{
                    width: '100%',
                    height: 'fit-content',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'top'
                  }}
                >
                  {get(avaliacao, 'is_processual')&& (
                    <div
                      style={{
                        marginTop: '-1.25rem',
                        height: '24px',
                        display: 'inline-flex',
                        padding: '4px 10px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '10px',
                        borderRadius: '0px 0px 4px 4px',
                        background: '#FCDFB4'
                      }}
                    >
                      <span
                        style={{
                          color: '#FB7225',
                          fontFamily: 'Public Sans',
                          fontSize: '14px',
                          fontStyle: 'normal',
                          fontWeight: '400',
                          lineHeight: 'normal'
                        }}
                      >
                        Processual
                      </span>
                    </div>
                  )}
                  {get(avaliacao, 'avaliacao_oficial') && (
                    <div
                      style={{
                        marginTop: '-1.25rem',
                        height: '24px',
                        display: 'inline-flex',
                        padding: '4px 10px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '10px',
                        borderRadius: '0px 0px 4px 4px',
                        background: 'rgba(30, 152, 79, 0.20)'
                      }}
                    >
                      <span
                        style={{
                          color: '#1E984F',
                          fontFamily: 'Public Sans',
                          fontSize: '14px',
                          fontStyle: 'normal',
                          fontWeight: '400',
                          lineHeight: 'normal'
                        }}
                      >
                        Oficial SESI
                      </span>
                    </div>
                  )}
                  {get(avaliacao, 'avaliacao_gpt_id') && (
                    <div
                      style={{
                        marginTop: '-1.25rem',
                        height: '24px',
                        display: 'inline-flex',
                        padding: '4px 10px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '10px',
                        borderRadius: '0px 0px 4px 4px',
                        background: 'rgba(0,71,182,0.2)'
                      }}
                    >
                      <span
                        style={{
                          color: '#0047B6',
                          fontFamily: 'Public Sans',
                          fontSize: '14px',
                          fontStyle: 'normal',
                          fontWeight: '400',
                          lineHeight: 'normal'
                        }}
                      >
                        PAE
                      </span>
                    </div>
                  )
                  }
                  {get(avaliacao, 'exame') == 15 && (
                    <div
                      style={{
                        marginTop: '-1.25rem',
                        height: '24px',
                        display: 'inline-flex',
                        padding: '4px 10px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '10px',
                        borderRadius: '0px 0px 4px 4px',
                        background: '#F7E707'
                      }}
                    >
                      <span
                        style={{
                          color: "#646464",
                          fontFamily: 'Public Sans',
                          fontSize: '14px',
                          fontStyle: 'normal',
                          fontWeight: '400',
                          lineHeight: 'normal'
                        }}
                      >
                        PPI
                      </span>
                    </div>
                  )
                  }

                  <IconButton
                    aria-label="more"
                    aria-controls="long-menu"
                    aria-haspopup="true"
                    onClick={this.openPreviewModal}
                  >
                    <VisibilityIcon />
                  </IconButton>
                  <IconButton
                    aria-label="more"
                    aria-controls="long-menu"
                    aria-haspopup="true"
                    onClick={(e) => {
                      this.analytcsClick(`More Actions avaliação ${avaliacao.id}`, 'Avaliação Card');
                      handleClick(e)
                    }}
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    className="menu-atividade"
                    id="long-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={open}
                    onClose={() => handleClose()}
                    PaperProps={{
                      style: {
                        maxHeight: 'fit-content',
                        width: 'fit-content'
                      }
                    }}
                  >
                    <MenuItem
                      onClick={() => {
                        this.analytcsClick(`More Actions: Enviar para aplicação avaliação ${avaliacao.id}`, 'Avaliação Card');
                        handleClose();
                        this.handleExportToExams();
                      }}
                    >
                      Enviar para aplicação
                    </MenuItem>
                    <MenuItem>
                      <Link
                        key={1}
                        id={`edit-${keyTooltip}`}
                        to={`/instrumentos-cognitivos/${avaliacao.id}/dados/tipo/${tipoId}`}
                        onClick={() => {
                          this.analytcsClick(`More Actions: Editar avaliação ${avaliacao.id}`, 'Avaliação Card');
                        }}
                      >
                        {`Editar ${categoria}`}
                      </Link>
                    </MenuItem>
                    {/* <MenuItem
                  onClick={() =>{
                    handleClose();
                    this.toggleImportarVetoresModal(null)
                  }}
                >
                  Importar vetores
                </MenuItem> */}
                    <MenuItem onClick={() => {
                      this.analytcsClick(`More Actions: Fazer uma cópia da avaliação ${avaliacao.id}`, 'Avaliação Card');
                      onCopy(avaliacao.id)
                    }}>
                      {`Fazer uma cópia da ${categoria}`}
                    </MenuItem>
                    <MenuItem>
                      <Link
                        key={5}
                        id={`print-${keyTooltip}`}
                        to={`/instrumentos-cognitivos/${avaliacao.id}/impressao`}
                        onClick={() => {
                          this.analytcsClick(`More Actions: Imprimir avaliação ${avaliacao.id}`, 'Avaliação Card');
                        }}
                      >
                        Imprimir
                      </Link>
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        this.analytcsClick(`More Actions: Exportar .doc avaliação ${avaliacao.id}`, 'Avaliação Card');
                        handleClose();
                        this.toggleExportarAvaliacaoModal(null);
                      }}
                    >
                      Exportar .doc
                    </MenuItem>
                    {haveApplication && (
                      <MenuItem
                        onClick={() => {
                          this.analytcsClick(`More Actions: Acompanhar avaliação ${avaliacao.id}`, 'Avaliação Card');
                          const urlEducat = window.location.origin;
                          let host;
                          switch (urlEducat) {
                            case `http://localhost:3000`:
                              host = `http://localhost:3001`
                              break

                            case `https://educat-sesi.didatti.net.br`:
                              host = `https://exams-sesi-2022.didatti.net.br`
                              break

                            case `https://educat-sesi-avaliacao.didatti.net.br`:
                              host = `https://exams-sesi-avaliacao-2022.didatti.net.br`
                              break

                            case `https://educat-dev-2022.didatti.net.br`:
                              host = `https://exams-dev-2022.didatti.net.br`
                              break

                            default:
                              host = getExamsUrl()
                              break
                          }
                          const exportLink = `/exams/dashboard/list?collection=${idCollection}`

                          const pathName = `/external-application-middleware?${queryString.stringify(
                            {
                              applicationName: 'exams',
                              path: exportLink,
                              forceLogout: false
                            }
                          )}`

                          window.open(pathName, '_self')
                        }}
                      >
                        Acompanhar aplicação
                      </MenuItem>
                    )}

                    {
                      (avaliacao.criado_por_id === this.props.userId ||
                        this.props.permissions.__all__) && <hr />
                    }

                    {
                      (avaliacao.criado_por_id === this.props.userId ||
                        this.props.permissions.__all__) && (
                        <MenuItem
                          className="delete-menu-atividade"
                          onClick={() => {
                            this.analytcsClick(`More Actions: Modal Apagar Avaliação ${avaliacao.id}`, 'Avaliação Card');
                            onRemove(avaliacao.id);
                          }}
                        >
                          Apagar
                        </MenuItem>
                      )
                    }
                  </Menu >
                  <ExportarAvaliacaoModal
                    isOpen={openModal === 'exportarAvaliacao'}
                    toggle={() => this.toggleExportarAvaliacaoModal(null)}
                    avaliacao={avaliacao}
                    fetchAplicacoes={this.fetchAplicacoes}
                    options={templates}
                  />
                  <ImportarVetoresModal
                    isOpen={openModal === 'importarVetores'}
                    toggle={() => this.toggleImportarVetoresModal(null)}
                    avaliacao={avaliacao}
                  />
                  <EnviarAplicacaoModal
                    isOpen={openModal === 'enviarAplicacao'}
                    toggle={() => this.toggleEnviarAvaliacaoModal(null)}
                    idCollection={idCollection}
                  />
                </div >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginBottom: '12px',
                    marginRight: '16px'
                  }}
                >
                  <CustumizeButton
                    variant="text"
                    color="primary"
                    onClick={() => {
                      this.analytcsClick(`Enviar para Aplicação ${avaliacao.id}`, 'Avaliação Card')
                      handleClose();
                      this.handleExportToExams();
                    }}
                  >
                    Enviar para Aplicação
                  </CustumizeButton>
                </div>
              </div>
            </div>
          </div>
          {this.renderAplicacoes()}
        </div>
      </>
    )
  }
}

export default withTheme(AvaliacaoItem)
